import { render } from "./DocumentAttachmentsDownload.vue?vue&type=template&id=3d50690c&scoped=true&ts=true"
import script from "./DocumentAttachmentsDownload.vue?vue&type=script&lang=ts"
export * from "./DocumentAttachmentsDownload.vue?vue&type=script&lang=ts"

import "./DocumentAttachmentsDownload.vue?vue&type=style&index=0&id=3d50690c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d50690c"]])

export default __exports__